import ContactFormSection from "../Components/ContactFormSection";

const aboutParagraphs = [
  "Trophy NNN Assets is a separate division at American Realty Network, a leading commercial real estate company that helps clients find, buy, sell, lease and manage commercial properties.",
  "We have a team of experienced and dedicated professionals who provide expert advice and tailored solutions for every type of commercial real estate need. Whether you are looking for office, retail, industrial, multifamily, hospitality or land, we have the market knowledge and the network to help you achieve your goals.",
  "Trophy NNN Assets is more than just a brokerage service. We are a partner who cares about your success and satisfaction. We are committed to delivering exceptional service and value to our clients, while also making a positive impact on our communities.",
  "We use cutting-edge technology and data-driven insights to enhance our services and optimize our results. We also foster a culture of collaboration and innovation among our agents and staff, who share our vision and values.",
  "We are a group of passionate and visionary entrepreneurs who saw an opportunity to transform the commercial real estate industry. Since then, we have grown to become one of the most trusted and respected names in the market, with expert agents in major cities and regions across the country. We have also established strategic partnerships with global firms and organizations that share our commitment to excellence and integrity.",
  "Contact us today and let us show you why Trophy NNN Assets is the best choice for your commercial real estate needs.",
];

function AboutUs() {
  return (
    <div className="section-wrap py-10 lg:py-14">
      <section className="grid gap-6 xl:grid-cols-[minmax(0,1.35fr)_minmax(360px,0.65fr)]">
        <article className="premium-panel p-7 sm:p-10">
          
          <h1 className="mt-3 font-serif text-4xl leading-tight text-obsidian-950">ABOUT US</h1>
          <div className="mt-6 space-y-5">
            {aboutParagraphs.map((paragraph) => (
              <p key={paragraph} className="text-sm leading-7 text-obsidian-700">
                {paragraph}
              </p>
            ))}
          </div>
        </article>

        <aside>
          <ContactFormSection
            title="CONTACT FORM"
            className="xl:sticky xl:top-28"
          />
        </aside>
      </section>
    </div>
  );
}

export default AboutUs;
